export default __webpack_public_path__ + "static/media/icons-json.392ee426.svg";